import axios from "axios";
import Config from "./Config";
import store, { persistor } from "./../store/index";
import { installDataApiAuth, isDataApiAuthUrl } from "./dataApiAuth";

const API_HOST_ORIGIN = (() => {
  try {
    return new URL(Config.API_HOST_URL_live).origin;
  } catch (e) {
    return null;
  }
})();

// The .NET API (relative URLs resolve to it) or a data-API route that takes the token.
// Never any other origin, even if someone points this instance at a third-party URL.
export const isFigApiUrl = (url) => {
  if (!url || !/^https?:/i.test(url)) return true;
  try {
    if (new URL(url).origin === API_HOST_ORIGIN) return true;
  } catch (e) {
    return false;
  }
  return isDataApiAuthUrl(url);
};

const getLoginToken = () => store.getState()?.login?.LoginDetails?.accessToken;

// Every plain `axios.get/post/...` call in the app uses the default instance. This attaches
// the login token to data-API (azuresql) requests only — see dataApiAuth.js for the scope
// rules. Imported once from src/index.js so it is live before any module fires a request.
installDataApiAuth(axios, getLoginToken);

// const token = store.getState().login.LoginDetails.accessToken; // Retrieve token from storage

const Axios = axios.create({
  baseURL: Config.API_HOST_URL_live,
  // headers: {
  //   Authorization: `Bearer ${token}`,
  // },
});
// axios.defaults.headers.common["Authorization"] = `bearer ${access_token}`;
//             delete axios.defaults.headers.common["Authorization"];

Axios.interceptors.request.use(
  (config) => {
    const token = store.getState().login.LoginDetails.accessToken; // Retrieve token from storage
    if (token && isFigApiUrl(config.url)) {
      config.headers.Authorization = `Bearer ${token}`;
      // config.headers["Content-Type"] = `application/json`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  response => response,
  error => {

    if (error.response && error.response.status === 401) {
      // Dispatch reset action to clear Redux store
      store.dispatch({ type: "LOGOUT" });
      persistor.purge();
      // Optionally remove the token from headers (not necessary for your case)
      // delete api.defaults.headers.common['Authorization'];

      // Redirect to the login page
      // window.location.href = '/login'; // Adjust the path to your login route
    }
    return Promise.reject(error);
  }
);

// The custom instance already sends the token on every request (interceptor above); the
// scoped one is registered too so both instances share one rule for the data API.
installDataApiAuth(Axios, getLoginToken);

export default Axios;
